import { Injectable } from '@angular/core';
import {ApiService} from '../api/services/api.service';
import {ExhibitorData} from '../api/models/exhibitor-data';


@Injectable({
  providedIn: 'root'
})
export class ExhibitorService {

  constructor(private apiService: ApiService) { }

  public getExhibitorList() {
    return this.apiService.apiExhibitorsList();
  }

  public getExhibitorDetail(id: number){
    return this.apiService.apiExhibitorsRetrieve({id});
  }

  public getExhibitorData() {
    return this.apiService.apiExhibitordataList();
  }

  public orderDesks(data: ExhibitorData){
    return this.apiService.apiExhibitordataCreate$Json({ body: data});
  }

}

